import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../../provider/CommonContext";
import { Col, Container, Row } from 'react-bootstrap';
import './NiftyFutures.css';
import Pagination from '../../../CommonUI/Pagination/Pagination';
import { format, parseISO } from 'date-fns';
import MarketFandO from "../../MarketFandO";
import { Vortex } from 'react-loader-spinner'



function NiftyFutures() {
    const [data, setData] = useState([]);

    const [dataGroup, setDataGroup] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [loadingshow, setloadingshow] = useState(false);
    const { BaseURL } = useContext(URLstateContext);
    let getData, getDataGroup, eleBtn, eleBtnLoose, eleLi;
    let PageSize = 8;


    useEffect(() => {
        setloadingshow(true);
        const getUrl = BaseURL + "HighLowOpenIntrest";


        fetch(`${getUrl}/mw/-/FUTIDX/NIFTY/-/-/-/-/-`)
            .then((response) => response.json())
            .then((data) => {
                getData = data.data;
                setData(getData);
                setloadingshow(false);
                // console.log(getData, "getData")
            })
            .catch((error) => {
            });


    }, []);



    const currentTableData = useMemo(() => {
        if (data != null && data != []) {
            const firstPageIndex = (currentPage - 1) * PageSize;
            const lastPageIndex = firstPageIndex + PageSize;
            if (data != null && data != []) {
                if (data.length > 0) {
                    return data.slice(firstPageIndex, lastPageIndex);
                }
            }
        }
    }, [currentPage, data]);


    return (
        <>
            <div class="col-12 p-0 breadcrumMF ">
                <ul>
                    <li><a href="/">Home</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li><a href="/market/futures-and-options">F & O</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li>Nifty Futures</li>
                </ul>
            </div>
            <Container>
                <Row>
                    <Col sm={12}>
                        <section className='Niftyf-loser-sc'>
                            <div className='Niftyf-header'>
                                <h2><span>Nifty Futures</span></h2>
                            </div>
                            <MarketFandO optionValue="Nifty Futures" optionDrop="Derivative" />
                            {/* <hr className="Mosthr"></hr> */}
                            <div className='Niftyf-table table-responsive'>
                                <table className='table'>
                                    <thead>
                                        <tr>



                                            <th className='text-left' >Instrument Type</th>
                                            <th className='text-left' >Underlying</th>
                                            <th className='text-right'>Expiry Date</th>
                                            <th className='text-right'>Last Price(&#8377;)</th>
                                            <th className='text-right'>No Of Contracts Traded</th>
                                            <th className='text-right'>Turnover (&#8377; in CR)</th>

                                        </tr>

                                    </thead>
                                    <tbody>
                                        {currentTableData && currentTableData.map(

                                            ({ InstName, Symbol, ExpDate, TradedQty, Turnover, LTP }) => (
                                                <tr>
                                                    <td className="text-left"> {InstName}</td>
                                                    <td className="text-left"> {Symbol}</td>
                                                    <td className="text-right">{format(parseISO(ExpDate), 'dd-MMM-yyyy')}</td>

                                                    <td className="text-right"> {(LTP != null) ? LTP.toFixed(2) : 0}</td>
                                                    <td className="text-right"> {(TradedQty != null) ? TradedQty.toFixed(2) : 0}</td>
                                                    <td className="text-right"> {(Turnover != null) ? Turnover.toFixed(2) : 0}</td>

                                                </tr>
                                            ))}
                                    </tbody>
                                </table>
                                {loadingshow ? <div className="textcentervertex">
                                                        <Vortex
                                                            visible={true}
                                                            height="80"
                                                            width="80"
                                                            ariaLabel="vortex-loading"
                                                            wrapperStyle={{}}
                                                            wrapperClass="vortex-wrapper"
                                                            colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                                        />
                                                        <div className="model_popup">Please Wait...</div>
                                                    </div> : ""
                                                    }
                            </div>
                            {(data != null && data != []) ?
                                <Pagination
                                    className="pagination-bar_peer"
                                    currentPage={currentPage}
                                    totalCount={(data.length != null) ? data.length : 0}
                                    pageSize={PageSize}
                                    onPageChange={page => setCurrentPage(page)}
                                /> : <p className="errorPeer"> No Data Found !!! </p>}

                        </section>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default NiftyFutures;